module.exports = __webpack_public_path__ + "img/ИФ-1(А)-023.da2a58a5.png";